module.exports = __webpack_public_path__ + "media/images/shared/suppliers/WEBASTO-9aeac48dcd4fdabf1d0c1c621f8aa52a.jpg";